import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { DataBlocks } from 'components';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

const BonusesBanner = ({ imageUrl, url }) => (
  <DataBlocks.AnimationWrapper>
    <a
      href={url}
      className={cx('banner')}
      style={{
        backgroundImage: `url(${imageUrl})`,
      }}
    />
  </DataBlocks.AnimationWrapper>
);

BonusesBanner.propTypes = {
  imageUrl: PropTypes.string,
  url: PropTypes.string,
};

export default BonusesBanner;
